import { render, staticRenderFns } from "./inline-radio.vue?vue&type=template&id=8d50845e"
import script from "./inline-radio.vue?vue&type=script&lang=js"
export * from "./inline-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports